import React from 'react';
import styles from './WhatsAppButton.module.css';

const WhatsAppButton = () => {
  const whatsappUrl = 'https://wa.me/972502177062?text=' +
    encodeURIComponent('היי מורן, הגעתי מהאתר שלך ואשמח שנדבר על..');

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.button}
      aria-label="שלחו הודעה בוואטסאפ"
    >
      <svg viewBox="0 0 32 32" className={styles.icon}>
        <path
          d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.914 15.914 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.31 22.608c-.39 1.098-1.932 2.01-3.174 2.276-.852.18-1.962.324-5.702-1.226-4.786-1.984-7.862-6.834-8.1-7.15-.228-.316-1.916-2.55-1.916-4.864 0-2.314 1.212-3.452 1.642-3.924.39-.428.924-.62 1.248-.62.15 0 .284.008.406.014.43.018.644.042.928.718.354.842 1.216 2.956 1.322 3.17.108.214.214.504.068.79-.136.294-.256.476-.47.732-.214.256-.45.572-.642.768-.214.214-.436.448-.188.878.248.43 1.104 1.82 2.372 2.948 1.632 1.452 3.006 1.902 3.434 2.112.43.214.68.178.928-.108.256-.286 1.096-1.274 1.388-1.712.286-.43.578-.356.972-.214.398.144 2.508 1.182 2.938 1.398.43.214.718.324.824.504.108.178.108 1.038-.282 2.136z"
          fill="currentColor"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
